import React from 'react';
import { Wine } from 'lucide-react';

const DRINK_CATEGORIES = ['soft_drinks', 'cocktails', 'beers', 'shakes'];

const QuickDrinkButton = ({ onSelectCategory }) => {
  return (
    <button
      onClick={() => onSelectCategory(DRINK_CATEGORIES[0])}
      className="fixed bottom-20 right-4 z-40 w-14 h-14 rounded-full bg-gradient-to-br from-[#D4A853] to-[#C4983F] text-black shadow-lg shadow-[#D4A853]/30 flex items-center justify-center hover:scale-110 active:scale-95 transition-transform"
      data-testid="quick-drink-btn"
      title="Commander une boisson"
    >
      <Wine className="w-6 h-6" />
    </button>
  );
};

export { DRINK_CATEGORIES };
export default QuickDrinkButton;
